<div class="wrapper d-flex flex-column">
  <qm-filters
    [filterDefinitions]="filters"
    [range]="true"
    (filtersChanged)="filtersChanged($event)"
    [position]="'left'" style="width:100%;"
    [initialDateRange]="initialDateRange">
  </qm-filters>
  <ng-container *ngIf="alarmList?.data">
      <div class="alarms-list">
          <div *ngFor="let alarm of alarmList.data" class="d-flex flex-column"
               (mouseenter)="setActive(alarm)" (mouseleave)="setActive(null);">
            <div class="d-flex flex-row alarm">
              <div class="alarm-icon">
                <fa-icon
                  [icon]="[(isAlarmNew | applyFunction:alarm.timestamp:(time$ | async)) ? 'fas' : 'fal', 'exclamation-triangle']"
                  [ngStyle]="{
                    color: alarm.metadata.active ? '#d9534f' : '#2f5b94',
                    'font-size': '2em'
                  }"
                  [ngbTooltip]="alarm.metadata.active ? ('Active' | translate) : ('Inactive' | translate)">
                </fa-icon>
              </div>
              <div
                class="definition"
                [ngStyle]="{'flex-direction': 'row', 'align-items': 'center'}">

                <div
                  [ngStyle]="{width: '100%', 'flex-direction': 'column'}"
                  class="d-flex align-items-start middle">

                  <div class="small-text">
                    <div class="timestamps">
                      <span *ngFor="let extra of (getExtras | applyFunction:alarm)">{{extra}} ∙ </span>
                      <span>{{(isActive | applyFunction:alarm:active) ? (alarm.timestamp | qmDateFormat:'HH:mm:ss dd.MM.yyyy') : (alarm.timestamp | qmDateDistance)}}</span>
                    </div>
                    <span *ngIf="alarm.metadata.active === true && alarm.metadata.userdisabled === true">{{ 'Active alarm disabled by user' | translate }}</span>
                    <span *ngIf="alarm.metadata.active === false && alarm.metadata.userdisabled === false">{{ 'Inactive alarm enabled by user' | translate }}</span>
                  </div>

                  <ng-container [ngSwitch]="currentTenantId">
                    <div *ngSwitchCase="2" [ngStyle]="{width: '100%'}">
                      <qm-train-list-alarm [alarm]="alarm" [ngStyle]="{width: '100%'}"></qm-train-list-alarm>
                    </div>

                    <div
                      *ngSwitchDefault
                      [ngStyle]="{
                      'display': 'flex',
                      'justify-content': 'space-between',
                      'width': '100%'
                    }">
                      <span class="d-flex flex-start">
                      {{alarm.message | translate | qmReplace: alarm.translate}}</span>
                    </div>
                  </ng-container>

                </div>

              </div>

              <qm-alarm-item-menu [alarm]="alarm" (alarmRemoved)="removeAlarmFromUI(alarm)"></qm-alarm-item-menu>

            </div>
          </div>
        </div>
        <div style="width: 100%; margin-top: 0.2em;" class="d-flex justify-content-center">
          <ngb-pagination
            (pageChange)="turnPage($event)"
            [page]="paginationValues.page"
            [pageSize]="paginationValues.limit"
            [maxSize]="10"
            [collectionSize]="alarmList.total"></ngb-pagination>
        </div>
  </ng-container>
</div>

<i class="fal fa-exclamation-triangle" data-fa-symbol="exclamation"></i>
<i class="fal fa-crosshairs" data-fa-symbol="crosshair"></i>
<i class="fas fa-info-circle" data-fa-symbol="info"></i>
